export default "//cdn.scentbird.com/assets/frontbird-site/images/scotch_34dc82.jpg";